import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

export const CustomerIcon = (props: SvgIconProps) => {
  const { ...rest } = props;
  return (
    <SvgIcon {...rest}>
      <svg viewBox="0 0 21 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5003 5.83333V4.16667C10.5003 3.25 9.75033 2.5 8.83366 2.5H3.83366C2.91699 2.5 2.16699 3.25 2.16699 4.16667V15.8333C2.16699 16.75 2.91699 17.5 3.83366 17.5H17.167C18.0837 17.5 18.8337 16.75 18.8337 15.8333V7.5C18.8337 6.58333 18.0837 5.83333 17.167 5.83333H10.5003ZM5.50033 15.8333H3.83366V14.1667H5.50033V15.8333ZM5.50033 12.5H3.83366V10.8333H5.50033V12.5ZM5.50033 9.16667H3.83366V7.5H5.50033V9.16667ZM5.50033 5.83333H3.83366V4.16667H5.50033V5.83333ZM8.83366 15.8333H7.16699V14.1667H8.83366V15.8333ZM8.83366 12.5H7.16699V10.8333H8.83366V12.5ZM8.83366 9.16667H7.16699V7.5H8.83366V9.16667ZM8.83366 5.83333H7.16699V4.16667H8.83366V5.83333ZM16.3337 15.8333H10.5003V14.1667H12.167V12.5H10.5003V10.8333H12.167V9.16667H10.5003V7.5H16.3337C16.792 7.5 17.167 7.875 17.167 8.33333V15C17.167 15.4583 16.792 15.8333 16.3337 15.8333ZM15.5003 9.16667H13.8337V10.8333H15.5003V9.16667ZM15.5003 12.5H13.8337V14.1667H15.5003V12.5Z" />
      </svg>
    </SvgIcon>
  );
};

export const CustomerAddIcon = (props: SvgIconProps) => {
  const { ...rest } = props;
  return (
    <SvgIcon {...rest}>
      <svg viewBox="0 0 21 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.33334 5.33333V3.66667C9.33334 2.75 8.58334 2 7.66666 2H2.66666C1.75 2 1 2.75 1 3.66667V15.3333C1 16.25 1.75 17 2.66666 17H12.333V15.3333H9.33334V13.6667H11V12H9.33334V10.3333H11V8.66667H9.33334V7H15.1667C15.625 7 16 7.375 16 7.83333V11.5H17.6667V7C17.6667 6.08333 16.9167 5.33333 16 5.33333H9.33334ZM4.33334 15.3333H2.66666V13.6667H4.33334V15.3333ZM4.33334 12H2.66666V10.3333H4.33334V12ZM4.33334 8.66667H2.66666V7H4.33334V8.66667ZM4.33334 5.33333H2.66666V3.66667H4.33334V5.33333ZM7.66666 15.3333H6V13.6667H7.66666V15.3333ZM7.66666 12H6V10.3333H7.66666V12ZM7.66666 8.66667H6V7H7.66666V8.66667ZM7.66666 5.33333H6V3.66667H7.66666V5.33333Z"
        />
        <path d="M14.3333 8.66667H12.6667V10.3333H14.3333V8.66667Z" />
        <path d="M12.6667 12H14.3333V13.6667H12.6667V12Z" />
        <path d="M16.125 16.875H14.375C13.8938 16.875 13.5 16.4813 13.5 16C13.5 15.5188 13.8938 15.125 14.375 15.125H16.125V13.375C16.125 12.8938 16.5187 12.5 17 12.5C17.4813 12.5 17.875 12.8938 17.875 13.375V15.125H19.625C20.1063 15.125 20.5 15.5188 20.5 16C20.5 16.4813 20.1063 16.875 19.625 16.875H17.875V18.625C17.875 19.1063 17.4813 19.5 17 19.5C16.5187 19.5 16.125 19.1063 16.125 18.625V16.875Z" />
      </svg>
    </SvgIcon>
  );
};

export const CustomerSearchIcon = (props: SvgIconProps) => {
  const { ...rest } = props;
  return (
    <SvgIcon {...rest}>
      <svg viewBox="0 0 21 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.33334 3.66667V5.33333H16C16.9167 5.33333 17.6667 6.08333 17.6667 7V11H16V7.83333C16 7.375 15.625 7 15.1667 7H9.33334V8.66667H11V10.3333H9.33334V12H11V13.6667H9.33334V15.3333H11.5V17H2.66666C1.75 17 1 16.25 1 15.3333V3.66667C1 2.75 1.75 2 2.66666 2H7.66666C8.58334 2 9.33334 2.75 9.33334 3.66667ZM2.66666 15.3333H4.33334V13.6667H2.66666V15.3333ZM2.66666 12H4.33334V10.3333H2.66666V12ZM2.66666 8.66667H4.33334V7H2.66666V8.66667ZM2.66666 5.33333H4.33334V3.66667H2.66666V5.33333ZM6 15.3333H7.66666V13.6667H6V15.3333ZM6 12H7.66666V10.3333H6V12ZM6 8.66667H7.66666V7H6V8.66667ZM6 5.33333H7.66666V3.66667H6V5.33333Z"
        />
        <path d="M12.6667 8.66667H14.3333V10.3333H12.6667V8.66667Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2196 14.6906C18.2578 15.3206 18.086 15.8932 17.7806 16.3832L19.3139 17.9103C19.562 18.1585 19.562 18.5657 19.3139 18.8139C19.0658 19.062 18.6586 19.062 18.4105 18.8139L16.8772 17.2804C16.4382 17.5604 15.9165 17.7258 15.3566 17.7258C13.7788 17.7258 12.5 16.4468 12.5 14.8624C12.5 13.1698 13.9633 11.8272 15.6938 12.0181C17.049 12.1645 18.1369 13.3225 18.2196 14.6906ZM13.7724 14.8624C13.7724 15.7405 14.485 16.4532 15.363 16.4532C16.241 16.4532 16.9535 15.7405 16.9535 14.8624C16.9535 13.9843 16.241 13.2716 15.363 13.2716C14.485 13.2716 13.7724 13.9843 13.7724 14.8624Z"
        />
      </svg>
    </SvgIcon>
  );
};

export const ApplicantIcon = (props: SvgIconProps) => {
  const { ...rest } = props;
  return (
    <SvgIcon {...rest}>
      <svg viewBox="0 0 21 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.83333 10C10.675 10 12.1667 8.50833 12.1667 6.66666C12.1667 4.82499 10.675 3.33333 8.83333 3.33333C6.99167 3.33333 5.5 4.82499 5.5 6.66666C5.5 8.50833 6.99167 10 8.83333 10ZM8.83333 4.99999C9.75 4.99999 10.5 5.74999 10.5 6.66666C10.5 7.58333 9.75 8.33333 8.83333 8.33333C7.91667 8.33333 7.16667 7.58333 7.16667 6.66666C7.16667 5.74999 7.91667 4.99999 8.83333 4.99999Z" />
        <path d="M3.83366 15C4.01699 14.4 6.59199 13.3333 8.83366 13.3333C8.83366 12.75 8.94199 12.1917 9.12533 11.675C6.85033 11.5917 2.16699 12.725 2.16699 15V16.6667H10.117C9.68366 16.1833 9.34199 15.625 9.12533 15H3.83366Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6823 15.9091C14.9375 15.9091 15.955 14.8916 15.955 13.6364C15.955 12.3812 14.9375 11.3636 13.6823 11.3636C12.4271 11.3636 11.4095 12.3812 11.4095 13.6364C11.4095 14.8916 12.4271 15.9091 13.6823 15.9091ZM13.6823 17.2727C15.6906 17.2727 17.3186 15.6447 17.3186 13.6364C17.3186 11.6281 15.6906 10 13.6823 10C11.674 10 10.0459 11.6281 10.0459 13.6364C10.0459 15.6447 11.674 17.2727 13.6823 17.2727Z"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M13.2275 12.0455H14.1366V13.5827L15.201 14.1149L14.7945 14.928L13.2275 14.1446V12.0455Z" />
      </svg>
    </SvgIcon>
  );
};

export const TimeRegistrationIcon = (props: SvgIconProps) => {
  const { ...rest } = props;
  return (
    <SvgIcon {...rest}>
      <svg viewBox="0 0 22 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.33334 3.66667V5.33333H16C16.9167 5.33333 17.6667 6.08333 17.6667 7V11H16V7.83333C16 7.375 15.625 7 15.1667 7H9.33334V8.66667H11V10.3333H9.33334V12H11V13.6667H9.33334V15.3333H11.5V17H2.66666C1.75 17 1 16.25 1 15.3333V3.66667C1 2.75 1.75 2 2.66666 2H7.66666C8.58334 2 9.33334 2.75 9.33334 3.66667ZM2.66666 15.3333H4.33334V13.6667H2.66666V15.3333ZM2.66666 12H4.33334V10.3333H2.66666V12ZM2.66666 8.66667H4.33334V7H2.66666V8.66667ZM2.66666 5.33333H4.33334V3.66667H2.66666V5.33333ZM6 15.3333H7.66666V13.6667H6V15.3333ZM6 12H7.66666V10.3333H6V12ZM6 8.66667H7.66666V7H6V8.66667ZM6 5.33333H7.66666V3.66667H6V5.33333Z"
        />
        <path d="M12.6667 8.66667H14.3333V10.3333H12.6667V8.66667Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2196 14.6906C18.2578 15.3206 18.086 15.8932 17.7806 16.3832L19.3139 17.9103C19.562 18.1585 19.562 18.5657 19.3139 18.8139C19.0658 19.062 18.6586 19.062 18.4105 18.8139L16.8772 17.2804C16.4382 17.5604 15.9165 17.7258 15.3566 17.7258C13.7788 17.7258 12.5 16.4468 12.5 14.8624C12.5 13.1698 13.9633 11.8272 15.6938 12.0181C17.049 12.1645 18.1369 13.3225 18.2196 14.6906ZM13.7724 14.8624C13.7724 15.7405 14.485 16.4532 15.363 16.4532C16.241 16.4532 16.9535 15.7405 16.9535 14.8624C16.9535 13.9843 16.241 13.2716 15.363 13.2716C14.485 13.2716 13.7724 13.9843 13.7724 14.8624Z"
        />
      </svg>
    </SvgIcon>
  );
};

export const Invoice = forwardRef((props: SvgIconProps, ref: React.Ref<SVGSVGElement>) => {
  const { ...rest } = props;
  return (
    <SvgIcon {...rest} ref={ref}>
      <path d="M9,7H15V9H11V11H14V13H11V17H9V7M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z" />
    </SvgIcon>
  );
});

Invoice.displayName = "Invoice";
